module.exports = __webpack_public_path__ + "img/lock-blue.3e5b81ae.svg";